import React from 'react';
import { PAGE_CONFIG } from './pageConfig'
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';

import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';

const reqParams = '/overview/xh-daily';
const DailyXh = () => {
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG}/>
    </>
  );
};

export default DailyXh;
